import React from 'react';
import PropTypes from 'prop-types';

import {ENTER} from 'core/constants.js';
import autobind from 'common/decorators/autobind.js';
import Icon from 'core/components/Icon.js';

export default class CollapsibleSection extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        enabled: PropTypes.bool,
        section: PropTypes.string,
        action: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {
            enabled: props.enabled,
        };
    }

    componentDidUpdate(prevProps) {
        const {enabled, action} = this.props;
        if (prevProps.enabled !== enabled) {
            this.setState({
                enabled,
            });
        }
        if (action) {
            action();
        }
    }

    @autobind
    handleKeyDown(evt) {
        if (evt.key === ENTER) {
            this.toggleCollapse();
        }
    }

    @autobind
    toggleCollapse() {
        this.setState((state) => ({
            enabled: !state.enabled,
        }));
    }

    render() {
        return (
            <>
                <h3
                    aria-expanded={this.state.enabled}
                    label={`${this.props.label}`}
                    onClick={this.toggleCollapse}
                    onKeyDown={this.handleKeyDown}
                    tabIndex="0"
                >
                    <Icon name="dropDown" />
                    {this.props.section}
                </h3>
                {this.state.enabled && this.props.children}
            </>
        );
    }
}
